import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
  const { darkMode } = useContext(ThemeContext);
  
  return (
    <div className={`min-h-screen flex flex-col ${darkMode ? 'dark' : ''} bg-gray-50 dark:bg-gray-900`}>
      <Navbar />
      <div className="pt-16 px-4 sm:px-5 lg:px-7 flex-grow">
        <div className="max-w-[1440px] mx-auto py-10">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">About Us</h1>

          <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Story</h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Founded in 2020 by a team of automotive experts and software engineers, Torque was created to address the unique challenges faced by auto repair businesses in managing their operations efficiently.
            </p>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              We recognized that many repair shops were still using outdated methods for invoicing and customer management, leading to inefficiencies, errors, and lost revenue. Our mission is to provide a comprehensive, user-friendly solution that streamlines these processes.
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              Today, Torque is used by hundreds of automotive businesses across the country, helping them save time, reduce errors, and improve customer satisfaction.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Mission</h2>
            <p className="text-gray-700 dark:text-gray-300">
              Our mission at Torque is to empower automotive service businesses with the technology they need to streamline operations, increase efficiency, and provide exceptional customer service. We believe that by providing intuitive, powerful software tools, we can help these businesses focus on what they do best – servicing vehicles – rather than getting bogged down in administrative tasks.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Values</h2>
            <ul className="list-disc pl-5 space-y-2 text-gray-700 dark:text-gray-300">
              <li><strong>Customer-Centric:</strong> We prioritize the needs of our customers in everything we do.</li>
              <li><strong>Innovation:</strong> We're constantly looking for new ways to improve our product and stay ahead of industry trends.</li>
              <li><strong>Reliability:</strong> We build software that our customers can depend on, with uptime and performance as top priorities.</li>
              <li><strong>Simplicity:</strong> We believe that powerful software doesn't have to be complicated to use.</li>
              <li><strong>Integrity:</strong> We are honest and transparent in all our business dealings.</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;